/// <reference path="../typings/index.d.ts" />
namespace App.Modulos {
  export class SniperDetalhes {
    public static inicializar() {
      let sniperDetalhes = new App.SniperDetalhes();
      sniperDetalhes.inicializarEventos();
    }
  }
}

namespace App {
  export class SniperDetalhes {
    private ajax: IAjax;
    private ehAdmin: boolean;
    private idExtensao: string = "pnenhoomfmddepcbmmkpkbdoplmjohge";
    public valorInvestido: number;
    public snipou: number;
    public disputaPerdida: number;
    public cartasEncontradas: number;
    public valorFutbin: number;
    public keyStorageCachePrecoFutbin: string = "key_storage_cache_preco_futbin";
    public minutosCachePrecoFutbin: number = 1440; //1440 24 horas
    public static objPlayers: IPlayerJson = null;
    public static objJogadorDefault: any = { "f": "Nao", "id": 0, "l": "Identificado", "r": 0 };

    private elBtnLimparCachePrecoFutbin: JQuery = $("#limparCachePrecoFutbin");
    private elSectionSniperDetalhes: JQuery = $(".section-sniper-detalhes");

    private objFiltros: any = {};
    private objServidores: any = {};
    private servidoresMap: Map<string, string> = new Map<string, string>();

    private elDropdownSubstituirFiltroPro: JQuery = $(".substituir-filtro-pro");
    private elBotaoMenuSubstituirFiltroPro: JQuery = $(".menu-substituir-filtro");
    private objFiltroCopia: any = {};

    public async inicializarEventos() {
      var idExtensao: any = await App.Util.aguardarValorElemento('#idExtensao');
      this.ehAdmin = this.elSectionSniperDetalhes.data('ehAdmin');
      if (idExtensao) {
        this.idExtensao = idExtensao
      }

      let params = new URLSearchParams(window.location.href)
      if (params.get('extension_id')) {
        this.idExtensao = params.get('extension_id')
      }

      this.getMensagemLimiteDiasFiltro();

      // console.log('usuario: ', ehAdmin);

      await this.getPlayers();
      this.prepararDadosSnipersAdmin();


      this.elBtnLimparCachePrecoFutbin.on('click', (e) => { this.aoLimparCachePrecoFutbin(e); });
      this.elDropdownSubstituirFiltroPro.on("click", (e) => { this.aoSubstituirFiltroPro(e) });
    }

    private getMensagemLimiteDiasFiltro() {
      let seletorAreaMensagemLimiteDias: JQuery = $("#areaMensagem");
      let limiteDias = $('#areaMensagem').data('limite-dias');
      if (limiteDias) {
        seletorAreaMensagemLimiteDias.show();
      }
    }

    private async sleep(milisegundos: number) {
      return new Promise((resolve: any) => setTimeout(resolve, milisegundos));
    }

    private getPlayers(): Promise<void> {
      return new Promise<void>((resolve: () => void) => {
        App.Util.getPlayersJson().then((players: any) => {
          SniperDetalhes.objPlayers = players;
          resolve();
        });
      });
    }

    private normalizarPrecoFutbin(dados: IFutbin): number {
      if (!dados || !dados.hasOwnProperty('preco')) {
        return 0;
      }

      let preco = Number(dados.preco);
      return isFinite(preco) && preco > 0 ? preco : 0;
    }

    private getNomeJogador(player: any): string {
      if (!player) {
        return 'Nao Identificado';
      }

      if (player.hasOwnProperty('c') && player.c) {
        return player.c;
      }

      let nome = `${player.f || ''} ${player.l || ''}`.trim();
      return nome ? nome : 'Nao Identificado';
    }

    private getFiltroBuscaPreco(sniper: any): any {
      let player = SniperDetalhes.objPlayers ? App.Util.getItemArrayById(SniperDetalhes.objPlayers, sniper.asset_id, SniperDetalhes.objJogadorDefault) : SniperDetalhes.objJogadorDefault;
      let nomeJogador = this.getNomeJogador(player);
      return {
        name: nomeJogador,
        termo: nomeJogador,
        rating: sniper.rating,
        rareflag: sniper.rareflag,
        teamId: sniper.team_id,
        assetId: sniper.asset_id,
        resourceId: sniper.resource_id
      };
    }

    private addCachePrecoFutbin(itemCache: IStoragePrecoFutbin) {

      let objStoragePrecoFutbin: IStoragePrecoFutbin[] = App.Util.getArrayStorage(this.keyStorageCachePrecoFutbin) || [];
      if (objStoragePrecoFutbin && objStoragePrecoFutbin.length) {
        if (App.Util.arrayExistByResourceId(objStoragePrecoFutbin, itemCache.resourceId)) {
          let index = App.Util.getIndiceArrayByResourceId(objStoragePrecoFutbin, itemCache.resourceId);
          objStoragePrecoFutbin[index] = itemCache;
        } else {
          objStoragePrecoFutbin.push(itemCache);
        }
      } else {
        objStoragePrecoFutbin.push(itemCache);
      }

      App.Util.setArrayStorage(this.keyStorageCachePrecoFutbin, objStoragePrecoFutbin);
    }

    private getPrecoFutbin(resource_id: number, id_plataforma: number, filtroBusca: any = null): Promise<IFutbin> {
      return new Promise(async (resolve: any, reject: any) => {

        try {
          let objStoragePrecoFutbin: IStoragePrecoFutbin[] = App.Util.getArrayStorage(this.keyStorageCachePrecoFutbin) || [];
          let item: IStoragePrecoFutbin = objStoragePrecoFutbin && objStoragePrecoFutbin.length ? App.Util.getItemArraySeExistResourceId(objStoragePrecoFutbin, resource_id) : null;
          let itemTemCacheValido: boolean = item && item.preco && this.normalizarPrecoFutbin(item.preco) > 0 && item.update_at && (App.Util.getMinutosPassadosPartirDaDataInicial(new Date(item.update_at), new Date()) < this.minutosCachePrecoFutbin);

          if (itemTemCacheValido) {
            resolve(item.preco);
          } else {
            await this.sleep(App.Util.getRandomInt(50, 1000));
            chrome.runtime.sendMessage(this.idExtensao, {
              evento: "bpftb",
              idJogador: resource_id,
              platform: id_plataforma == 3 ? 'pc' : 'ps',
              nomeJogador: filtroBusca && filtroBusca.name ? filtroBusca.name : null,
              termo: filtroBusca && filtroBusca.termo ? filtroBusca.termo : null,
              filtroBusca: filtroBusca
            },
              (resultado: { response: IFutbin, status: boolean }) => {
                if (resultado && resultado.status && resultado.response && this.normalizarPrecoFutbin(resultado.response) > 0) {
                  this.addCachePrecoFutbin({ update_at: new Date().toISOString(), resourceId: resource_id, preco: resultado.response });
                  resolve(resultado.response);
                } else {
                  resolve(null);
                }
              });
          }
        } catch (error) {
          console.log('ERROR: ', error);
          resolve(null);
        }
      });
    }

    private async inserirValorFutbinSniperDetalhes(dados: IFutbin) {
      let seletorValorFutbin: JQuery = $(".ressourceId-" + dados.id);
      seletorValorFutbin.text(dados.preco.toLocaleString('pt-BR'));
      //let seletorAtualizacaoFutbin: JQuery = $(".atualizacao-" + dados.id);
      //seletorAtualizacaoFutbin.text(dados.ultimaAtualizacao);
    }

    private async calcularLucro() {
      let seletorLucro: JQuery = $("#lucro");
      let seletorStatusLucro: JQuery = $("#lucroStatus");


      let taxaEA = this.valorFutbin * 0.05;
      let lucro = this.valorFutbin - taxaEA - this.valorInvestido;

      if (lucro >= 0) {
        $('.lucroProfit').addClass('text-success');
        seletorStatusLucro.html('<i class="fas fa-arrow-up text-success mr-3"></i>');
      } else {
        $('.lucroProfit').addClass('text-danger');
        seletorStatusLucro.html('<i class="fas fa-arrow-down text-danger mr-3"></i>');
      }
      seletorLucro.text(lucro.toLocaleString('pt-BR'));

    }

    private async preencherCampos() {
      let seletorSomaFutbin: JQuery = $("#valorSomaFutbin");
      let seletorValorInvestido: JQuery = $("#valorInvestido");
      let seletorQuantidadeDisputasGanhas: JQuery = $("#disputasGanhas");
      let seletorQuantidadeDisputasPerdidas: JQuery = $("#disputasPerdidas");
      let seletorPorcentagemSnipada: JQuery = $("#porcentagemSnipada");
      let qtdCartasEncontradas: any = $("#cartasEncontradas").text().trim()
      qtdCartasEncontradas = qtdCartasEncontradas ? parseInt(qtdCartasEncontradas.toString()) : 0;

      seletorQuantidadeDisputasGanhas.text(this.snipou);
      seletorQuantidadeDisputasPerdidas.text(this.disputaPerdida);
      seletorValorInvestido.text(this.valorInvestido.toLocaleString('pt-BR'));
      seletorSomaFutbin.text(this.valorFutbin.toLocaleString('pt-BR'));

      let porcentagem = (this.snipou / (this.snipou + qtdCartasEncontradas)) * 100;
      porcentagem = isNaN(porcentagem) ? 0 : porcentagem;

      const isPorcentagemAlta = porcentagem >= 8;
      const classToAdd = isPorcentagemAlta ? 'text-success' : 'text-danger';
      const styleToAddDiv = isPorcentagemAlta
        ? 'background:rgb(109, 212, 177) none repeat scroll 0% 0% / auto padding-box border-box;border-radius:10px;transition:0.5s;padding:41px 30px;position:relative;box-sizing:border-box;'
        : 'background:rgb(198, 76, 76) none repeat scroll 0% 0% / auto padding-box border-box;border-radius:10px;transition:0.5s;padding:41px 30px;position:relative;box-sizing:border-box;';

      $('#areaTaxaAcerto').attr('style', styleToAddDiv);

      const emojiClass = isPorcentagemAlta ? 'fa-smile' : 'fa-frown';
      const porcentagemText = `% ${porcentagem.toFixed(2)} <i class="fa ${emojiClass}" aria-hidden="true"></i>`;

      seletorPorcentagemSnipada.html(porcentagemText);
    }

    private async mostrarInformacoes() {
      let seletorAreaLoading: JQuery = $(".area-loading");
      let seletorAreaEstatisticas: JQuery = $(".area-estatisticas");
      seletorAreaEstatisticas.show();
      seletorAreaLoading.hide();
    }

    private aoLimparCachePrecoFutbin(e: JQueryEventObject) {
      localStorage.removeItem(this.keyStorageCachePrecoFutbin);
      window.location.reload();

    }

    private async prepararDadosSnipersAdmin() {
      // console.log('prepararDadosSnipersAdmin');
      let objSnipers = $('#cardDadosSnipers').data('dadosSnipers');
      this.objFiltros = {};
      this.objServidores = {};
      let valorFutbin: number = 0;
      let valorInvestido: number = 0;
      let disputaGanha: number = 0;
      let disputaPerdida: number = 0;
      let cartasEncontradas: number = 0;
      // console.log('jogadores: ', objSnipers);

      const tradeIdsVistos = new Set<string>();
      for await (const [index, sniper] of objSnipers.entries()) {

        // Garante que objFiltros[sniper.filtro.id] exista
        if (sniper.filtro && !this.objFiltros[sniper.filtro.id]) {
          this.objFiltros[sniper.filtro.id] = { id: sniper.filtro.id, nome: sniper.filtro.nome, status: sniper.filtro.status, data: sniper.filtro, estatisticas: { valorFutbin: 0, valorInvestido: 0, disputaGanha: 0, disputaPerdida: 0, cartasEncontradas: 0, disputaTotal: 0, lucro: 0 } };
        }

        if (sniper.ip && !this.objServidores[sniper.ip]) {
          this.objServidores[sniper.ip] = { ip: sniper.ip, nome: sniper.ip, estatisticas: { valorFutbin: 0, valorInvestido: 0, disputaGanha: 0, disputaPerdida: 0, cartasEncontradas: cartasEncontradas, disputaTotal: 0, lucro: 0 } };
        }

        if (sniper.filtro) {
          this.objFiltros[sniper.filtro.id].estatisticas.disputaTotal++;
        }

        if (sniper.ip) {
          this.objServidores[sniper.ip].estatisticas.disputaTotal++;
        }

        let tradeId = sniper && sniper.trade_id ? String(sniper.trade_id) : null;
        // console.log('tradeId: ', tradeId, sniper);
        if (tradeId && !tradeIdsVistos.has(tradeId)) {
          tradeIdsVistos.add(tradeId);
          if (sniper.filtro) {
            this.objFiltros[sniper.filtro.id].estatisticas.cartasEncontradas++;
          }

          if (sniper.ip) {
            this.objServidores[sniper.ip].estatisticas.cartasEncontradas++;
          }

          cartasEncontradas++;
        }

        if (sniper.status == 1) {
          let dados: IFutbin = await this.getPrecoFutbin(sniper.resource_id, sniper.id_plataforma, this.getFiltroBuscaPreco(sniper));
          if (dados) {
            await this.inserirValorFutbinSniperDetalhes(dados);
            valorFutbin += dados.preco;
            valorInvestido += sniper.valor;

            if (sniper.filtro) {
              this.objFiltros[sniper.filtro.id].estatisticas.valorFutbin += dados.preco;
              this.objFiltros[sniper.filtro.id].estatisticas.valorInvestido += sniper.valor;
            }

            if (sniper.ip) {
              this.objServidores[sniper.ip].estatisticas.valorFutbin += dados.preco;
              this.objServidores[sniper.ip].estatisticas.valorInvestido += sniper.valor;
            }
          }

          if (sniper.filtro) {
            this.objFiltros[sniper.filtro.id].estatisticas.disputaGanha++;
          }

          if (sniper.ip) {
            this.objServidores[sniper.ip].estatisticas.disputaGanha++;
          }

          disputaGanha++;
        } else {
          if (sniper.filtro) {
            this.objFiltros[sniper.filtro.id].estatisticas.disputaPerdida++;
          }

          if (sniper.ip) {
            this.objServidores[sniper.ip].estatisticas.disputaPerdida++;
          }

          disputaPerdida++;
        }
      }

      this.valorFutbin = valorFutbin;
      this.valorInvestido = valorInvestido;
      this.snipou = disputaGanha;
      this.disputaPerdida = disputaPerdida;
      this.cartasEncontradas = cartasEncontradas;

      // console.log("INVESTIMENTO: ", this.valorInvestido, 'FUTBIN: ', this.valorFutbin, 'snipou: ', this.snipou, 'perdeu: ', this.disputaPerdida);
      await this.preencherCampos();
      await this.calcularLucro();
      await this.mostrarInformacoes();
      await this.calcularLucroFiltros();
      await this.calcularLucroServidores();
    }

    private async calcularLucroFiltros() {
      // console.log('calcularLucroFiltros: ', this.objFiltros);
      // Mapeia os filtros em this.objFiltros e adiciona a propriedade 'lucro'
      for (const filtroId in this.objFiltros) {
        if (this.objFiltros.hasOwnProperty(filtroId)) {
          const filtro = this.objFiltros[filtroId];
          if (!filtro.estatisticas.disputaTotal) {
            continue
          }
          // Calcula o lucro com base nos valores de 'valorFutbin' e 'valorInvestido'
          const lucro = (filtro.estatisticas.valorFutbin || 0) - (filtro.estatisticas.valorInvestido || 0);
          let porcentagem: any = (filtro.estatisticas.disputaGanha / filtro.estatisticas.cartasEncontradas) * 100;
          porcentagem = isNaN(porcentagem) ? 0 : porcentagem.toFixed(2);
          // Adiciona a propriedade 'lucro' ao filtro
          filtro.estatisticas.lucro = lucro;
          filtro.estatisticas.porcentagem = porcentagem;
        }
      }

      // Exibe os filtros atualizados no console
      // console.log("Filtros atualizados com lucro:", this.objFiltros);
      // ordene os filtros por lucro
      this.objFiltros = (Object as any).values(this.objFiltros).sort((a: any, b: any) => {
        return b.estatisticas.lucro - a.estatisticas.lucro;
      });
      // Preenche a tabela .tabela-estatisticas-filtros com os dados dos filtros, incluindo disputas ganhas, perdidas e totais
      let seletorTabelaFiltros: JQuery = $(".tabela-estatisticas-filtros");
      seletorTabelaFiltros.find('tbody').empty();

      for (const filtroId in this.objFiltros) {
        if (this.objFiltros.hasOwnProperty(filtroId)) {
          const filtro = this.objFiltros[filtroId];
          if (!filtro.estatisticas.disputaTotal) {
            continue
          }
          let seletorTr: JQuery = $('<tr></tr>').attr('data-filtro-id', filtroId);
          let seletorTdLucro: JQuery = $('<td></td>');
          let seletorTdPorcentagem: JQuery = $('<td></td>');
          let seletorTdNome: JQuery = $('<td></td>');
          let seletorTdStatus: JQuery = $('<td></td>');
          let seletorTdDisputasGanhas: JQuery = $('<td></td>');
          let seletorTdCartasEncontradas: JQuery = $('<td></td>');
          let seletorTdDisputasPerdidas: JQuery = $('<td></td>');
          let seletorTdDisputasTotais: JQuery = $('<td></td>');

          let classLucro = filtro.estatisticas.lucro > 0 ? 'text-success' : 'text-danger';
          let iPorcentagem = filtro.estatisticas.porcentagem >= 10
            ? '<i class="fa fa-smile text-success" aria-hidden="true"></i>'
            : '<i class="fa fa-frown text-danger" aria-hidden="true"></i>';

          seletorTdLucro.html('<img src="/img/icons/coinIcon.png" class="mr-2" style="width: 18px;height: 18px;"></i>' + `<span class="font-weight-bold font-size-16 ${classLucro}">${filtro.estatisticas.lucro.toLocaleString('pt-BR')}</span>`);
          seletorTdPorcentagem.html(iPorcentagem + '<span class="ml-2 text-sm">' + filtro.estatisticas.porcentagem + '%</span>');
          seletorTdNome.html(`<span class="font-weight-bold">${filtro.id} | ${filtro.nome}</span>`);
          seletorTdStatus.html(`<i class="fa-solid fa-circle mr-1 ${filtro.status ? 'text-success' : ''}"></i><span>${filtro.status ? 'ativo' : 'inativo'}</span>`);

          // Preenche as colunas de disputas ganhas, perdidas e totais
          seletorTdDisputasGanhas.html(`<span class="text-success">${filtro.estatisticas.disputaGanha || 0}</span>`);
          seletorTdCartasEncontradas.html(`<span class="text-info">${filtro.estatisticas.cartasEncontradas || 0}</span>`);
          seletorTdDisputasPerdidas.html(`<span class="text-danger">${filtro.estatisticas.disputaPerdida || 0}</span>`);
          seletorTdDisputasTotais.text(filtro.estatisticas.disputaTotal || 0);

          seletorTr.append(seletorTdLucro);
          seletorTr.append(seletorTdPorcentagem);
          seletorTr.append(seletorTdNome);
          seletorTr.append(seletorTdStatus);
          seletorTr.append(seletorTdDisputasGanhas);
          seletorTr.append(seletorTdCartasEncontradas);
          seletorTr.append(seletorTdDisputasPerdidas);
          seletorTr.append(seletorTdDisputasTotais);

          // Adiciona o evento de clique na linha
          seletorTr.on('click', (e) => {
            this.selecionarFiltroASerSubstituido(e);
          });

          seletorTabelaFiltros.append(seletorTr);
        }
      }
    }

    private async calcularLucroServidores() {
      // console.log('calcularLucroServidores: ', this.objServidores);
      // Mapeia os filtros em this.objFiltros e adiciona a propriedade 'lucro'
      for (const servidorId in this.objServidores) {
        if (this.objServidores.hasOwnProperty(servidorId)) {
          const servidor = this.objServidores[servidorId];
          if (!servidor.estatisticas.disputaTotal) {
            continue
          }
          // Calcula o lucro com base nos valores de 'valorFutbin' e 'valorInvestido'
          const lucro = (servidor.estatisticas.valorFutbin || 0) - (servidor.estatisticas.valorInvestido || 0);
          let porcentagem: any = (servidor.estatisticas.disputaGanha / servidor.estatisticas.cartasEncontradas) * 100;
          porcentagem = isNaN(porcentagem) ? 0 : porcentagem.toFixed(2);
          // Adiciona a propriedade 'lucro' ao filtro
          servidor.estatisticas.lucro = lucro;
          servidor.estatisticas.porcentagem = porcentagem;
        }
      }

      // ordene os filtros por lucro
      this.objServidores = (Object as any).values(this.objServidores).sort((a: any, b: any) => {
        return b.estatisticas.lucro - a.estatisticas.lucro;
      });

      // Preenche a tabela .tabela-estatisticas-filtros com os dados dos filtros, incluindo disputas ganhas, perdidas e totais
      let seletorTabelaFiltros: JQuery = $(".tabela-estatisticas-servidores");
      try {
        let servidoresNomes: any = seletorTabelaFiltros.data('servidores-nomes');
        if (servidoresNomes) {
          this.servidoresMap = new Map<string, string>((Object as any).entries(servidoresNomes));
        }
      } catch (e) {
        console.log('Erro ao converter servidoresNomes: ', e);
      }
      // Converte o json encode para um objeto javascript

      seletorTabelaFiltros.find('tbody').empty();

      for (const servidorId in this.objServidores) {
        if (this.objServidores.hasOwnProperty(servidorId)) {
          const servidor = this.objServidores[servidorId];
          if (!servidor.estatisticas.disputaTotal) {
            continue
          }
          let seletorTr: JQuery = $('<tr></tr>').attr('data-servidor-id', servidorId);
          let seletorTdLucro: JQuery = $('<td></td>');
          let seletorTdPorcentagem: JQuery = $('<td></td>');
          let seletorTdNome: JQuery = $('<td></td>');
          let seletorTdDisputasGanhas: JQuery = $('<td></td>');
          let seletorTdCartasEncontradas: JQuery = $('<td></td>');
          let seletorTdDisputasPerdidas: JQuery = $('<td></td>');
          let seletorTdDisputasTotais: JQuery = $('<td></td>');
          let classLucro = servidor.estatisticas.lucro > 0 ? 'text-success' : 'text-danger';
          let iPorcentagem = servidor.estatisticas.porcentagem >= 10
            ? '<i class="fa fa-smile text-success" aria-hidden="true"></i>'
            : '<i class="fa fa-frown text-danger" aria-hidden="true"></i>';
          seletorTdLucro.html('<img src="/img/icons/coinIcon.png" class="mr-2" style="width: 18px;height: 18px;"></i>' + `<span class="font-weight-bold font-size-16 ${classLucro}">${servidor.estatisticas.lucro.toLocaleString('pt-BR')}</span>`);
          seletorTdPorcentagem.html(iPorcentagem + '<span class="ml-2 text-sm">' + servidor.estatisticas.porcentagem + '%</span>');
          seletorTdNome.html(`<span class="font-weight-bold">${this.servidoresMap.get(servidor.ip) || servidor.ip}</span>`);
          // Preenche as colunas de disputas ganhas, perdidas e totais
          seletorTdDisputasGanhas.html(`<span class="text-success">${servidor.estatisticas.disputaGanha || 0}</span>`);
          seletorTdCartasEncontradas.html(`<span class="text-info">${servidor.estatisticas.cartasEncontradas || 0}</span>`);
          seletorTdDisputasPerdidas.html(`<span class="text-danger">${servidor.estatisticas.disputaPerdida || 0}</span>`);
          seletorTdDisputasTotais.text(servidor.estatisticas.disputaTotal || 0);
          seletorTr.append(seletorTdLucro);
          seletorTr.append(seletorTdPorcentagem);
          seletorTr.append(seletorTdNome);
          seletorTr.append(seletorTdDisputasGanhas);
          seletorTr.append(seletorTdCartasEncontradas);
          seletorTr.append(seletorTdDisputasPerdidas);
          seletorTr.append(seletorTdDisputasTotais);

          seletorTabelaFiltros.append(seletorTr);
        }
      }
    }

    private aoSubstituirFiltroPro(e: JQueryEventObject) {
      if (!this.ehAdmin) {
        return
      }
      this.ajax = new App.Ajax();

      var filtroASerSubstituido: IFiltroOptions = $(e.currentTarget).data('filtro');
      filtroASerSubstituido.id = $(e.currentTarget).data('id');
      filtroASerSubstituido.nome = $(e.currentTarget).data('nome');

      let formSniperPro: any = $(e.currentTarget).parents('#formSniperPro');
      let dadosForm: any = this.ajax.convertFormToJSON(formSniperPro);
      let nomeFiltro = formSniperPro.find('input[name=campo_nome_filtro]').val()
      // console.log("dadosForm", dadosForm, filtroASerSubstituido)

      let dadosFormatado = _.omit(dadosForm, ['descanso', 'intervalo', 'limite_compra', 'piloto_automatico', 'tempo', 'velocidade']);
      dadosFormatado.nome = nomeFiltro ? nomeFiltro : 'COPIADO_' + new Date().toLocaleDateString();

      if (App.Util.validarFiltroSniper(dadosForm)) {
        swal.fire({
          title: `Deseja substituir o filtro selecionado ${filtroASerSubstituido.nome}?`,
          text: `Após confirmar, o filtro selecionado será substituído pelos novos dados de filtro atual do formulário com nome de ${dadosFormatado.nome}.`,
          icon: 'warning',
          confirmButtonText: 'Substituir',
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          confirmButtonColor: "#db5250",
          allowOutsideClick: true,
          allowEscapeKey: true
        }).then((result: any) => {
          if (result.isConfirmed) {
            this.ajax.postAcaoSemCabecalhoGlobal(formSniperPro.find('.menu-substituir-filtro').data("url-substituir-filtro-modal-sniper") + '/' + filtroASerSubstituido.id, dadosFormatado, (objResposta: IRespostaAjaxPostAcao) => {
              if (objResposta.status == '200' && objResposta.dadosRetornados) {
                toastr.success(`Filtro ${filtroASerSubstituido.nome} substituído por ${dadosFormatado.nome}`, "Sucessso!");
              } else {
                toastr.warning("Algum erro ocorreu, o filtro não pode ser substituído.", "Não Substituído!");
              }
            }, null, false);
          }
        });
      }
    }

    private selecionarFiltroASerSubstituido(e: JQueryEventObject) {
      let filtroId = $(e.currentTarget).data('filtroId');
      // console.log('filtroId: ', filtroId);
      this.objFiltroCopia = this.objFiltros[filtroId].data;
      // console.log('filtro: ', this.objFiltroCopia);
      this.elBotaoMenuSubstituirFiltroPro.find('input[name=id_filtro_copiar]').val(filtroId);
      this.elBotaoMenuSubstituirFiltroPro.find('input[name=campo_nome_filtro]').val(this.objFiltroCopia.nome_original);
    }
  }
}
